import { getCurrentLocaleCode } from "@mongez/localization";

export function formatTransNumber(value: number | string): string {
  if (!value) return "0";

  return value.toLocaleString();
}

export function translateNumber(formattedValue: string): string {
  const lang = getCurrentLocaleCode();
  const arabicNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

  return formattedValue
    .split("")
    .map((digit) =>
      lang === "ar" && !isNaN(parseInt(digit, 10))
        ? arabicNumbers[parseInt(digit, 10)]
        : digit,
    )
    .join("");
}

export function numTrans(value: number | string): string {
  const formattedValue = formatTransNumber(value);
  return translateNumber(formattedValue);
}
